import React from 'react';

import Popup from '../../Popup';
import styles from './welcomePopUps.scss';

class PostScoreWelcomePopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {
            welcomeTitles,
            onCloseClick,
            onCtaClick,
        } = this.props;

        return (
            <Popup
                className={`popup-md`}
                popUpClassName={`${styles.welcomePopUp}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        {`${welcomeTitles.title}`}
                        <span className="d-block">
                            {`${welcomeTitles.subTitle}`}
                        </span>
                    </h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <p>
                        {welcomeTitles.description}
                    </p>
                    <div className="bb" />
                    <button
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={onCtaClick}
                        type="button"
                    >
                        Got It
                    </button>
                </div>
            </Popup>
        );
    }
}

export default PostScoreWelcomePopUp;

export const PostScoreWelcomeTitles = {
    PLAYER_POST: {
        title: 'Post your scores to count towards your rating.',
        subTitle: '',
        description: (
            <>
                Once approved by your opponent(s), scores will be posted publicly on player profiles and ratings will be updated by the next day.
            </>
        ),
    },
    CLUB_POST: {
        title: 'Post club scores!',
        subTitle: 'Post singles and doubles match scores to count towards your club members’ ratings.',
        description: 'Results will immediately show on club and player profiles but can be edited afterwards. Player ratings will update by the next day.',
    },
    TEAM_POST: {
        title: 'Post scores!',
        subTitle: 'Post JV, Challenge Matches, or any unofficial high school results.',
        description: (
            <>
                Results will immediately show on team and player profiles but can be edited afterwards. Player ratings will update by the next day.
                <br />
                If you’re looking to post Dual Match or Official High School results, click  “Create Event” on your team’s homepage
            </>
        ),
    },
};
